'use client';

import React from 'react';
import Image from 'next/image';
import SecuredByRazorpayImage from '@/lib/SecuredByRazorpay/assets/secured-by-razorpay.svg';

const SecuredByRazorpay = (): JSX.Element => {
  return (
    <Image className="m-auto mb-3 d:mb-0" src={SecuredByRazorpayImage} alt="Secured by Razorpay" />
  );
};

export default SecuredByRazorpay;
